import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ContextMenu } from '@feathr/components';
import { getIconForAction } from '@feathr/hooks';

function GeoFiltersOptions(): JSX.Element {
  const { t } = useTranslation();
  return (
    <ContextMenu buttonType={'icon'} name={'geoFilters-options'} position={'left-start'}>
      <ContextMenu.Item name={'edit-geoFilter'} prefix={getIconForAction('edit')}>
        {t('Edit')}
      </ContextMenu.Item>
      <ContextMenu.Item name={'assign-geoFilter-as-default'} prefix={getIconForAction('check')}>
        {t('Assign as default')}
      </ContextMenu.Item>
      <ContextMenu.Item
        name={'delete-geoFilter'}
        prefix={getIconForAction('delete')}
        theme={'danger'}
      >
        {t('Delete')}
      </ContextMenu.Item>
    </ContextMenu>
  );
}

export default GeoFiltersOptions;
